<template>
  <div>
    <div class="BlockList">
      <div class="BlockList-W">
        <div class="BlockList_Inp"><Homseach></Homseach></div>
        <div class="verfery">
          <div class="verfery_list">
            <div class="verfery_tit">Verify & Publish Contract Source Code</div>
            <div class="verfery_cont">
              Contract verification is an impotant step through which you can
              confirm the authenticity and transparency of the smart contract
              you've writtenby validating it against the already deployed smart
              contract code on the blockchain network.You just need to upload
              your smart contract code toinitiate the verification process
            </div>
            <div class="verfery_box">
              <el-form ref="form" :model="form" :rules="rules">
                <div class="verfery_li">
                  <div class="verfery_litit">Contract Address :</div>
                  <div class="verfery_licon">
                    <el-form-item prop="contractAddress" >
                      <el-input
                        v-model.trim="form.contractAddress"
                        class="inpttext"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="verfery_li">
                  <div class="verfery_litit">Contract Language :</div>
                  <div class="verfery_licon">
                    <el-form-item prop="contractLanguage">
                      <el-input
                        v-model="form.contractLanguage"
                        :readonly="isReadOnly"
                        class="inpttext"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="verfery_li">
                  <div class="verfery_litit">Contract Version :</div>
                  <div class="verfery_licon">
                    <el-form-item prop="compileVersion" style="background-color: #181B21 !important;padding: 0px !important;margin: 0px!important;">
                      <el-select
                        v-model="form.compileVersion"
                        placeholder="Please select"
                        :popper-append-to-body="false"
                        class="inpttext"
                        style="background-color: #181B21 !important;"
                      >
                        <el-option
                          v-for="item in options1"
                          :key="item.value"
                          :label="item.label"
                          
                          :value="item.value"
                          style="background-color: #181B21 !important;padding-top: 10px;"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item prop="address">
                      <el-input
                        v-model="form.address"
                        class="inpttext"
                      ></el-input>
                    </el-form-item> -->
                  </div>
                </div>
                <div class="verfery_li">
                  <div class="verfery_litit">License :</div>
                  <div class="verfery_licon">
                    <el-form-item prop="licence"   style="background-color: #181B21 !important;padding: 0px !important;margin: 0px!important;">
                      <el-select
                        v-model="form.licence"
                        placeholder="Please select"
                        :popper-append-to-body="false"
                        class="inpttext"
                        style="background-color: #181B21 !important;border: none !important;"
                      >
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          style="background-color: #181B21 !important;padding-top: 10px;"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <div class="verfery_li" style="margin-bottom: 16px !important">
                  <div class="verfery_litit">Contract Code :</div>
                  <!-- <div class="verfery_btn"><input
                    type="button"
                    value="Upload Contract File"
                    id="fileImport"
                    v-on:click="clickLoad"
                 
                  />
                  <input
                    type="file"
                    id="files"
                    ref="refFile"
                    style="display: none"
                    v-on:change="fileLoad"
                  /></div> -->

                  <div class="verfery_btn">
                    <el-upload
                      accept=".sol, .txt, .text"
                      action="https://explorer.tfsc.io/tfscBrowser/contract/uploadSolFile"
                      :limit="1"
                      :on-change="handleChange"
                      :before-upload="beforeUpload"
                      :on-success="upSuccess"
                      :on-error="upError"
                      ref="upload"
                    >
                      <el-button size="small">
                        <span class="iconfont icon-shangchuan" />Upload Contract
                        File
                      </el-button>
                    </el-upload>
                  </div>

                  <!-- <div class="verfery_context"></div> -->
                </div>
                <div class="verfery_li">
                  <div class="verfery_litit"></div>
                  <div class="verfery_licons">
                    <el-form-item prop="sourceCode">
                    <!-- <editor
                      v-model="form.sourceCode"
                      @init="editorInit"
                      @input="codeChange"
                      lang="java"
                      :options="editorOptions"
                      theme="vibrant_ink"
                    ></editor> -->
                    <el-input type="textarea" v-model="form.sourceCode" :rows="16"></el-input>
                    </el-form-item>
                  </div>
      
                </div>
                <div class="verfery_li">
                  <div class="verfery_litit" style="width: 300px !important">
                    Constructor Arguments ABI-encoded : <br />(for contracts
                    that were created with <br />constructor parameters)
                  </div>
                  <div
                    class="verfery_licons"
                    style="
                      margin-left: 0px !important;
                      height: 123px !important;
                    "
                  >
                  <el-form-item prop="argumentsABIEncode">
                    <el-input type="textarea" v-model="form.argumentsABIEncode" :rows="6"></el-input>
                    
                    </el-form-item>
                  </div>
                  <!-- <div class="verfery_context"></div> -->
                </div>
                <div class="verfery_li" v-show="flog">
                  <div class="verfery_litit"></div>
                  <div class="verfery_licon1">
                    <div class="verfery_fail">
                      <img :src="imgnamef" />
                      <div>
                       {{ error }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="verfery_li">
                  <div class="verfery_litit"></div>
                  <div class="verfery_btna" @click="submitForm" :disabled="isDisabled">
                    Verify And Publish
                  </div>
                  <!-- <div class="verfery_context"></div> -->
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Listbox from "@/components/pc/Listbox.vue";
import Homseach from "@/components/pc/serch.vue";
import Homeinput from "../Home/Home_input.vue";
import Editor from "vue2-ace-editor";
import axios from "axios";
//黑底色
import "brace/theme/tomorrow_night_eighties";
//蓝底色
import "brace/theme/tomorrow_night_blue";
//黑底色
import "brace/theme/vibrant_ink";

import { GetvertifyContract } from "@/assets/server/api";
export default {
  data() {
    return {
      error:'',
      url:'192.168.1.241',
      isReadOnly: true,
      flog:false,
      isDisabled:false,
      imgnamef: require("@/assets/pc/TopValidators/fail.png"),
      form: {
        contractAddress: "", //第一个名字
        contractLanguage: "Solidity",
        sourceCode: "",
        compileVersion: "",
        licence: "",
        argumentsABIEncode: "",
        // lastName: "", //最后一个名字
      },
      rules: {
        contractAddress: [
          {
            required: true,
            message: "Contract Address  is required",
            trigger: "blur",
          },
          { min: 30, max: 45, message: "Contract address error", trigger: "blur" },
        ],

        compileVersion: [
          {
            required: true,
            message: "Contract Version  is required",
            trigger: 'change'
          },
        ],
        licence: [
          {
            required: true,
            message: "licence  is required",
            trigger: 'change'
          },
        ],
        sourceCode: [
          {
            required: true,
            message: "Contract Code  is required",
            trigger: "change",
          },
        ],
      },
      options: [
        {
          value: "No License (None)",
          label: "1) No License (None)",
        },
        {
          value: "The Unlicense (Unlicense)",
          label: "2) The Unlicense (Unlicense)",
        },
        {
          value: "MIT License (MIT)",
          label: "3) MIT License (MIT)",
        },
        {
          value: "GNU General Public License v2.0 (GNU GPLv2",
          label: "4) GNU General Public License v2.0 (GNU GPLv2",
        },
        {
          value: "GNU General Public License v3.0 (GNU GPLv3)",
          label: "5) GNU General Public License v3.0 (GNU GPLv3)",
        },
        {
          value: "GNU Lesser General Public License v2.1 (GNU LGPLv2.1)",
          label: "6) GNU Lesser General Public License v2.1 (GNU LGPLv2.1)",
        },
        {
          value: "GNU Lesser General Public License v3.0 (GNU LGPLv3)",
          label: "7) GNU Lesser General Public License v3.0 (GNU LGPLv3)",
        },
        {
          value: "BSD 2-clause 'Simplified' license (BSD-2-Clause)",
          label: "8) BSD 2-clause 'Simplified' license (BSD-2-Clause)",
        },
        {
          value: 'BSD 3-clause "New" Or "Revised" license (BSD-3-Clause)',
          label: '9) BSD 3-clause "New" Or "Revised" license (BSD-3-Clause)',
        },
        {
          value: "Mozilla Public License 2.0 (MPL-2.0)",
          label: "10) Mozilla Public License 2.0 (MPL-2.0)",
        },
        {
          value: "Open Software License 3.0 (OSL-3.0)",
          label: "11) Open Software License 3.0 (OSL-3.0)",
        },
        {
          value: "Apache 2.0 (Apache-2.0)",
          label: "12) Apache 2.0 (Apache-2.0)",
        },
        {
          value: "GNU Affero General Public License (GNU AGPLv3)",
          label: "13) GNU Affero General Public License (GNU AGPLv3)",
        },
        {
          value: "Business Source License (BSL 1.1)",
          label: "14) Business Source License (BSL 1.1)",
        },
      ],
      options1: [
        {
          value: "0821",
          label: "v0.8.21+commit.d9974bed",
        },
        {
          value: "0820",
          label: "v0.8.20+commit.a1b79de6",
        },
        {
          value: "0819",
          label: "v0.8.19+commit.7dd6d404",
        },
        {
          value: "0818",
          label: "v0.8.18+commit.87f61d96",
        },
        {
          value: "0817",
          label: "v0.8.17+commit.8df45f5f",
        },
        {
          value: "0816",
          label: "v0.8.16+commit.07a7930e",
        },
        {
          value: "0815",
          label: "v0.8.15+commit.e14f2714",
        },
        {
          value: "0814",
          label: "v0.8.14+commit.80d49f37",
        },
        {
          value: "0813",
          label: "v0.8.13+commit.abaa5c0e",
        },
        {
          value: "0812",
          label: "v0.8.12+commit.f00d7308",
        },
        {
          value: "0811",
          label: "v0.8.11+commit.d7f03943",
        },
        {
          value: "0810",
          label: "v0.8.10+commit.fc410830",
        },
        {
          value: "089",
          label: "v0.8.9+commit.e5eed63a",
        },
        {
          value: "088",
          label: "v0.8.8+commit.dddeac2f",
        },
        {
          value: "087",
          label: "v0.8.7+commit.e28d00a7",
        },
        {
          value: "086",
          label: "v0.8.6+commit.11564f7e",
        },
        {
          value: "085",
          label: "v0.8.5+commit.a4f2e591",
        },
        {
          value: "084",
          label: "v0.8.4+commit.c7e474f2",
        },
        {
          value: "083",
          label: "v0.8.3+commit.8d00100c",
        },
        {
          value: "082",
          label: "v0.8.2+commit.661d1103",
        },
        {
          value: "081",
          label: "v0.8.1+commit.df193b15",
        },
        {
          value: "080",
          label: "v0.8.0+commit.c7dfd78e",
        },
        {
          value: "076",
          label: "v0.7.6+commit.7338295f",
        },
        {
          value: "075",
          label: "v0.7.5+commit.eb77ed08",
        },
        {
          value: "074",
          label: "v0.7.4+commit.3f05b770",
        },
        {
          value: "073",
          label: "v0.7.3+commit.9bfce1f6",
        },
        {
          value: "072",
          label: "v0.7.2+commit.51b20bc0",
        },
        {
          value: "071",
          label: "v0.7.1+commit.f4a555be",
        },
        {
          value: "070",
          label: "v0.7.0+commit.9e61f92b",
        },
        {
          value: "0612",
          label: "v0.6.12+commit.27d51765",
        },
        {
          value: "0611",
          label: "v0.6.11+commit.5ef660b1",
        },
        {
          value: "0610",
          label: "v0.6.10+commit.00c0fcaf",
        },
        {
          value: "069",
          label: "v0.6.9+commit.3e3065ac",
        },
        {
          value: "068",
          label: "v0.6.8+commit.0bbfe453",
        },
        {
          value: "067",
          label: "v0.6.7+commit.b8d736ae",
        },
        {
          value: "066",
          label: "v0.6.6+commit.6c089d02",
        },
        {
          value: "065",
          label: "v0.6.5+commit.f956cc89",
        },
        {
          value: "064",
          label: "v0.6.4+commit.1dca32f3",
        },
        {
          value: "063",
          label: "v0.6.3+commit.8dda9521",
        },
        {
          value: "062",
          label: "v0.6.2+commit.bacdbe57",
        },
        {
          value: "061",
          label: "v0.6.1+commit.e6f7d5a4",
        },
        {
          value: "060",
          label: "v0.6.0+commit.26b70077",
        },
        {
          value: "0517",
          label: "v0.5.17+commit.d19bba13",
        },
        {
          value: "0516",
          label: "v0.5.16+commit.9c3226ce",
        },
        {
          value: "0515",
          label: "v0.5.15+commit.6a57276f",
        },
        {
          value: "0514",
          label: "v0.5.14+commit.01f1aaa4",
        },
        {
          value: "0513",
          label: "v0.5.13+commit.5b0b510c",
        },
        {
          value: "0512",
          label: "v0.5.12+commit.7709ece9",
        },
        {
          value: "v0511",
          label: "v0.5.11+commit.22be8592",
        },
        {
          value: "0511",
          label: "v0.5.11+commit.c082d0b4",
        },
        {
          value: "0510",
          label: "v0.5.10+commit.5a6ea5b1",
        },
        {
          value: "v059",
          label: "v0.5.9+commit.c68bc34e",
        },
        {
          value: "059",
          label: "v0.5.9+commit.e560f70d",
        },
        {
          value: "058",
          label: "v0.5.8+commit.23d335f2",
        },
        {
          value: "057",
          label: "v0.5.7+commit.6da8b019",
        },
        {
          value: "056",
          label: "v0.5.6+commit.b259423e",
        },
        {
          value: "055",
          label: "v0.5.5+commit.47a71e8f",
        },
        {
          value: "054",
          label: "v0.5.4+commit.9549d8ff",
        },
        {
          value: "053",
          label: "v0.5.3+commit.10d17f24",
        },
        {
          value: "052",
          label: "v0.5.2+commit.1df8f40c",
        },
        {
          value: "051",
          label: "v0.5.1+commit.c8a2cb62",
        },
        {
          value: "050",
          label: "v0.5.0+commit.1d4f565a",
        },
        {
          value: "0426",
          label: "v0.4.26+commit.4563c3fc",
        },
        {
          value: "0425",
          label: "v0.4.25+commit.59dbf8f1",
        },
        {
          value: "0424",
          label: "v0.4.24+commit.e67f0147",
        },
        {
          value: "0423",
          label: "v0.4.23+commit.124ca40d",
        },
        {
          value: "0422",
          label: "v0.4.22+commit.4cb486ee",
        },
        {
          value: "0421",
          label: "v0.4.21+commit.dfe3193c",
        },
        {
          value: "0420",
          label: "v0.4.20+commit.3155dd80",
        },
        {
          value: "0419",
          label: "v0.4.19+commit.c4cbbb05",
        },
        {
          value: "0418",
          label: "v0.4.18+commit.9cf6e910",
        },
        {
          value: "0417",
          label: "v0.4.17+commit.bdeb9e52",
        },
        {
          value: "0416",
          label: "v0.4.16+commit.d7661dd9",
        },
        {
          value: "v0415",
          label: "v0.4.15+commit.8b45bddb",
        },
        {
          value: "0415",
          label: "v0.4.15+commit.bbb8e64f",
        },
        {
          value: "0414",
          label: "v0.4.14+commit.c2215d46",
        },
        {
          value: "0413",
          label: "v0.4.13+commit.0fb4cb1a",
        },
        {
          value: "0412",
          label: "v0.4.12+commit.194ff033",
        },
        {
          value: "0411",
          label: "v0.4.11+commit.68ef5810",
        },
      ],
      editorOptions: {
        // 设置代码编辑器的样式
        wrap: true,
        // 设置代码编辑器的样式
        enableBasicAutocompletion: true, //启用基本自动完成
        enableSnippets: true, // 启用代码段
        //  enableLiveAutocompletion: true, //启用实时自动完成
        tabSize: 0, //标签大小
        fontSize: 14, //设置字号
        // readOnly: true,
        showPrintMargin: false, //去除编辑器里的竖线
        wrapBehavioursEnabled: true, //启用换行
        autoScrollEditorIntoView: false, //启用滚动
        showFoldWidgets: true, // 显示折叠部件
        fadeFoldWidgets: true, // 淡入折叠部件
      },
    };
  },
  components: {
    Homeinput,
    Homseach,
    Listbox,
    Editor,
  },
  created() {},
  mounted() {
    // this.BlockList();
  },
  methods: {
    handleChange(file, fileLists) {
     // this.form.sourceCode='';
   //  this.$children[0].$children[0].$refs.upload.clearFiles();
     // this.$refs.upload.clearFiles()
    //  console.log(file);
		//	console.log(fileLists);
			// 本地服务器路径
			// console.log(URL.createObjectURL(file.raw));
			// // 本地电脑路径
			// console.log(document.getElementsByClassName("el-upload__input")[0].value);
      // this.uplodes=document.getElementsByClassName("el-upload__input")[0].value;
		},
    async submitForm() {
      this.isDisabled = true;
      this.$refs.form.validate(async (success) => {
        console.log(this.form);
        if (success) {
          if (this.form.sourceCode.length > 0) {
        //    this.$refs.form.sourceCode.resetFields();
            axios
              .post(
               "https://explorer.tfsc.io/tfscBrowser/home/vertifyContract",
              //  "http://192.168.1.123:9200/tfscBrowser/home/vertifyContract",
               // this.url+"/ssg/vertifyContract",
                this.form,
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((res) => {
                // 请求成功状态为200说明添加成功
                // console.log(res);
                // console.log(res.data.code);
                // console.log(res.data.result);
                if (res.data.code == 200) {
               //   console.log(res.code);
                  this.flog=false;
                  this.isDisabled = false;
                  this.$router.push("/pc/sucess");
                  
                   this.$refs.form.resetFields();
                  // // 关闭用户新增表单弹窗
                  //  this.dialogFormVisible=false,
                  //  // 添加成功提示
                  // this.$message({showClose: true, message: '添加成功！',type: 'success', duration:2000,center:true});
                  // // 重新刷新列表数据
                  // this.queryUserList();
                } else  {
                 
                  this.error=res.data.result;
                  this.flog=true;
                  this.$refs.form.resetFields();
                  //this.$refs.form.resetFields();
                  return false;
                  
                 // alert(1111);
                  // this.$message({showClose: true, message: res.result,type: 'error', duration:2000,center:true});
                }
              })
              .catch((error) => {
                console.log(error);
                this.$message(" This field are not filled in ");
              });
          } else {
            this.$message("Contract Code   is required");
          //  this.$refs.form.resetFields();
            return false;
          }
        } else {
          this.$message(" This field are not filled in ");
          return false;
        }
      });
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);

      const whiteList = ["sol", "txt", "text"];

      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$msg("上传文件只能是 pdf、doc、docx、xls、xlsx格式", "error");
        this.$message("File uploads must be in the sol、txt format.");
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message("File uploads must not exceed 2MB in size.", "error");
        return false;
      }
    },
    // 上传成功
    upSuccess(res, file) {
      this.$refs.upload.clearFiles();

      this.jsonfileName = file.name;
      this.uploadSuccess = true;
      // let val=''
      let reader = new FileReader();
      reader.readAsText(file.raw, "UTF-8"); //读取，转换字符编码
      let vm = this;
      reader.onload = function (e) {
        vm.form.sourceCode = e.target.result; //获取数据

      //  console.log(vm.form.sourceCode);
        // if(vm.checkJSON(val)){
        //   vm.uploadSuccess=true
        //   vm.ruleForm.customRules=val
        // }else{
        //   vm.uploadSuccess=false
        //   vm.ruleForm.customRules=''
        //   vm.$message.error("JSON格式不符合规范");
        // }
      };
      // if (this.ruleForm.customRules) {
      //   this.$nextTick(()=>{
      //     this.$refs.ruleForm.clearValidate(["customRules"]);
      //   })
      // }
    },
    // 上传失败
    upError(e) {
      this.$message("上传失败", "error");
    },
    codeChange(val) {
      val;
       console.log(val)
    },
    editorInit() {
      require("brace/theme/chrome");
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/yaml");
      require("brace/mode/json");
      require("brace/mode/less");
      require("brace/snippets/json");
      require("brace/mode/lua");
      require("brace/snippets/lua");
      require("brace/mode/javascript");
      require("brace/snippets/javascript");
      require("brace/mode/python");
    },
    // async BlockList() {
    //   let formData = new FormData();
    //   let params = {
    //     pageNum: 1,
    //     pageSize: 10,
    //   };
    //   let item = params;
    //   for (const key in item) {
    //     if (Object.hasOwnProperty.call(item, key)) {
    //       formData.append(key, item[key]);
    //     }
    //   }
    //   let data = await GetBlockList(formData);
    //   console.log(data);
    // },
    // getpagenums(value) {
    //   console.log(value);
    // },
  },
};
</script>
<style lang="less">
/deep/ .el-select-dropdown__list {
  background-color: #181B21 !important;
  border: none !important;
  background: #181B21 !important;
  padding: 0px !important;
}
/deep/ .el-select-dropdown{
  background: #181B21 !important;
}
</style>
<style lang="less" scoped>
/deep/.el-popper{
  background: #181B21 !important;
}
/deep/.el-textarea__inner{

border: none !important; 
/* width: 806px; */
  /* height: 341px; */
background: #181B21 !important;
border-radius: 6px 6px 6px 6px;
opacity: 1;
color: #fff !important;
  /* color: #fff !important; */
  /* margin-left: 150px */
}
</style>


<style lang="less" scoped>

/deep/::-webkit-scrollbar {
  width: 0px !important; /*滚动条宽度*/
  height: 8px; /*滚动条高度*/
}
.el-textarea__inner::-webkit-scrollbar-thumb {
  background-color: rgba(168, 168, 168,.4);/*滚动条默认显示的颜色*/
}
 
/deep/.el-textarea__inner::-webkit-scrollbar {   
   width: 0px !important;   
   height: 8px;
   background-color: white;/*滚动条背景色显示的颜色*/
 }
input {
  border: none;
}
/deep/.el-button {
  background: #181B21 !important;
  border: none !important;
  color: #fff;
  width: 165px;
  height: 34px;

  border-radius: 6px 6px 6px 6px;
  opacity: 1;
}

/deep/.el-button {
  background-color: #181B21 !important;
  border: none !important;
  color: #fff;
}
/deep/.el-upload-list {
  display: none !important;
}
/deep/ button:hover {
  color: #06c083 !important;
}

/deep/ .el-select-dropdown__wrap{
  background: #181B21 !important;
}


/deep/ .el-select-dropdown {
  border: none;
  background: #181B21 !important;
}
/deep/.el-select-dropdown__item.hover {
  background-color: #181B21 !important;
}
/deep/.el-select-dropdown__item.selected {
  color: #06c083;
}
/deep/.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #181B21;
}
/deep/.el-input__inner {
  background-color: #181B21 !important;
  border: none;
  color: #FFF;
}
</style>
<style lang="less" scoped>

.BlockList {
  width: 100%;
  background: #13161b;
  .BlockList-W {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 36px;
    background: #13161b;
    .BlockList_Inp {
      padding: 40px 0;
    }
    .verfery {
      width: 1160px;
      height: 1154px;
      background: #0b0c0f;
      opacity: 1;
      border-radius: 20px;
      .verfery_list {
        width: 1080px;
        margin: 0 auto;
        .verfery_tit {
          padding-top: 28px;
          font-size: 20px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #ffffff;
        }
        .verfery_cont {
          height: 44px;
          font-size: 14px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #898b8d;
          line-height: 22px;
          margin-top: 10px;
        }
      }
      .verfery_box {
        margin-top: 40px;
        .verfery_li {
          display: flex;
          margin-bottom: 26px;
          .verfery_litit {
            height: 18px;
            font-size: 15px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #898b8d;
            line-height: 18px;
            width: 150px;
          }
          .verfery_licon1 {
            margin-left: 150px;
            .verfery_fail {
              width: 786px;
              height: 64px;
              background: rgba(206, 53, 75, 0.1);
              border-radius: 6px 6px 6px 6px;
              opacity: 1;
              display: flex;
              img {
                width: 24px;
                height: 24px;
                margin: 20px 16px;
              }
              div {
                font-size: 14px;
                font-family: Roboto-Regular, Roboto;
                font-weight: 400;
                color: #ff3d59;
                line-height: 20px;
                margin-top: 12px;
              }
            }
          }
          .verfery_licon {
            margin-left: 150px;
            width: 479px;
            height: 40px;
            background: #13161b;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;

            .inpttext {
              width: 479px;
              height: 40px;
              background: #13161b !important;
              border-radius: 6px 6px 6px 6px;
              opacity: 1;
            }
          }
          .verfery_btn {
            width: 165px;
            height: 34px;
            line-height: 34px;
            background: #181B21;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            margin-left: 150px;
            text-align: center;
            font-size: 15px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #ffffff;
            cursor: pointer;
          }
          .verfery_btna {
            width: 189px;
            height: 61px;
            line-height: 61px;
            background: #181B21;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            margin-left: 150px;
            text-align: center;
            color: #FFFFFF;
            // width: 165px;
            // height: 34px;
            // line-height: 34px;
            // background: #1c1e24;
            // border-radius: 6px 6px 6px 6px;
            // opacity: 1;
            // margin-left: 150px;
            // text-align: center;
            // font-size: 15px;
            // font-family: Roboto-Medium, Roboto;
            // font-weight: 500;
            // color: #ffffff;
          }
          .verfery_btna:hover {
            color: #00ffaa;
            cursor: pointer;
          }
          .verfery_context {
            width: 806px;
            height: 341px;
            background: #181B21;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            margin-top: 16px;
          }
          .verfery_licons {
            width: 806px;
            height: 341px;
            background: #181B21;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
            margin-left: 150px;
          }
        }
      }
    }
  }
}
</style>
